import React from "react";

/**
 * Переключатель «Вход / Регистрация / Восстановление пароля».
 *
 * Кнопки, а не ссылки. Reactstrap рендерит NavLink как <a> без адреса, и на
 * телефонах такое касание нередко не срабатывает: мобильный Safari не
 * считает ссылку без href кликабельной. Максим 22.08.2026 как раз не смог
 * открыть вкладки с телефона.
 *
 * Заодно это правильнее по сути: переключение вкладки — действие, а не
 * переход по адресу, и с клавиатуры кнопка доступна без ухищрений.
 *
 * Картинки убраны раньше: тема ставила рядом с каждым пунктом одну и ту же
 * иконку документа, ужатую до неузнаваемости — три серых квадрата,
 * читавшихся как битые изображения.
 */
const TABS = [
  { key: "login", title: "Вход" },
  { key: "register", title: "Регистрация" },
  { key: "forgot", title: "Восстановление пароля" },
];

const NavAuth = ({ callbackNav, selected }) => (
  <div className="fw-auth-tabs" role="tablist">
    {TABS.map((tab) => (
      <button
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={selected === tab.key}
        className={`nav-link${selected === tab.key ? " active" : ""}`}
        onClick={() => callbackNav(tab.key)}
      >
        {tab.title}
      </button>
    ))}
  </div>
);

export default NavAuth;
